import { z } from 'zod';
import { ConflictSchema, IsoInstantSchema, RuleViolationSchema } from './common.js';
export const AvailabilityQuerySchema = z
    .object({
    airshipId: z.coerce.number().int().positive(),
    from: IsoInstantSchema,
    to: IsoInstantSchema,
    passengers: z.coerce.number().int().min(1).max(200).optional(),
    /** Ignore this reservation when checking (used when re-confirming an existing one). */
    excludeReservationId: z.string().uuid().optional(),
})
    .refine((value) => new Date(value.to).getTime() > new Date(value.from).getTime(), {
    message: 'to must be strictly after from',
    path: ['to'],
});
export const AvailabilityResponseSchema = z.object({
    available: z.boolean(),
    airshipId: z.number().int().positive(),
    from: IsoInstantSchema,
    to: IsoInstantSchema,
    /** Blocking reservations, whether by raw overlap or by turnaround buffer. */
    conflicts: z.array(ConflictSchema),
    violations: z.array(RuleViolationSchema),
    turnaroundMinutes: z.number().int().nonnegative(),
});
/** Busy blocks for the booking calendar, including the greyed-out turnaround shoulders. */
export const BusyBlockSchema = z.object({
    reservationId: z.string().uuid().nullable(),
    kind: z.enum(['RESERVATION', 'TURNAROUND', 'MAINTENANCE']),
    startAt: IsoInstantSchema,
    endAt: IsoInstantSchema,
    label: z.string(),
});
export const CalendarQuerySchema = z.object({
    airshipId: z.coerce.number().int().positive(),
    from: IsoInstantSchema,
    to: IsoInstantSchema,
});
export const CalendarResponseSchema = z.object({
    airshipId: z.number().int().positive(),
    turnaroundMinutes: z.number().int().nonnegative(),
    blocks: z.array(BusyBlockSchema),
});
//# sourceMappingURL=availability.dto.js.map